import { useEffect, useRef, useState } from "react";

const BASE = `${process.env.PUBLIC_URL || ""}/game-assets`;

// Real Nicaragua photos that rotate behind the title menu. A shared warm grade
// (below) gives them all a cohesive feel without altering the photos themselves.
const BGS = [
  "bg_granada.webp",
  "bg_cerronegro.webp",
  "bg_bluefields_0.webp",
  "bg_bluefields_3.webp",
  "bg_treeoflife_home.webp",
];

export default function RotatingBackground() {
  const order = useRef(null);
  if (!order.current) {
    const start = Math.floor(Math.random() * BGS.length); // random start each visit
    order.current = [...BGS.slice(start), ...BGS.slice(0, start)];
  }
  const imgs = order.current;
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (imgs.length < 2) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % imgs.length), 7000);
    return () => clearInterval(id);
  }, [imgs.length]);

  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="rotating-bg" aria-hidden="true">
      {imgs.map((src, i) => (
        <img
          key={src}
          src={`${BASE}/${src}?v=8`}
          alt=""
          className={`absolute inset-0 w-full h-full object-cover object-center kenburns transition-opacity duration-[1600ms] ease-in-out ${i === idx ? "opacity-100" : "opacity-0"}`}
          style={{ filter: "saturate(1.08) contrast(1.04)" }}
        />
      ))}
      {/* Unifying warm grade — same feel across every photo */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "linear-gradient(180deg, rgba(255,150,40,0.14), rgba(255,120,30,0.04) 45%, rgba(10,15,30,0.30))", mixBlendMode: "soft-light" }}
      />
    </div>
  );
}
